import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { FilterMatchMode } from 'primereact/api';
import { Dialog } from 'primereact/dialog';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import AddEditCoScholasticTemplateDialog from './AddEditCoScholasticTemplate';
import moment from 'moment';
import Toast from '../../Shared/Toast/Toast';
import DeleteConfirmation from '../../Dialogs/DeleteConfirmation';
import { useCatchResponse } from '../../../utils/useCatchResponse';
import { Tooltip } from 'primereact/tooltip';


const CoScholasticTemplateConfiguration = () => {
    const { catchResponse } = useCatchResponse();
    const [coScholasticList, setCoScholasticTemplateList] = useState([]);
    const [masterData, setMasterData] = useState([]);
    const [visible, setVisible] = useState(false);
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        TemplateName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [securityUserID, setSecurityUserID] = useState("");
    const [rows, setRows] = useState(10);
    const [first, setFirst] = useState(0);
    const [isDeleteConfirmation, setIsDeleteConfirmation] = useState(false);
    const [deleteId, setDeleteId] = useState('');

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        GetCoScholasticTemplateList(loginData?._id);
    }, []);

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;
        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const onPageChange = (e) => {
        setFirst(e.first);
        setRows(e.rows);
    };

    const GetCoScholasticTemplateList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.GetCoScholasticTemplateList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setCoScholasticTemplateList(res.data);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) { console.log(err); 
            catchResponse(err);
        }
    }

    const actionBodyTemplate = (rows) => {
        return (
            <React.Fragment>
                <div className='p-d-flex p-ai-center'>
                    <Button icon="pi pi-pencil" className="e-sction-btn  p-m-1" onClick={() => {
                        setMasterData(rows);
                        setVisible(true)
                    }} />
                    <Button icon="pi pi-trash" className="e-sction-btn p-m-0 p-m-1" onClick={(e) => {
                        setIsDeleteConfirmation(true);
                        setDeleteId(rows._id);
                    }} />
                </div>
            </React.Fragment>

        );
    };

    const onCancel = () => {
        setVisible(false);
        setMasterData([]);
        GetCoScholasticTemplateList(securityUserID);
    }

    const actionBodyTemplateSrNo = (data, props) => {
        return props.rowIndex + 1;
    };

    const renderFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleClose}
            />
            <Button
                label="Delete"
                className="btn-text-action-primary"
                onClick={(e) => DeleteCoScholastic()}
            />
        </div>
    );

    const handleClose = () => {
        setIsDeleteConfirmation(false)
    };

    const DeleteCoScholastic = async () => {
        try {
            let data = {
                id: deleteId
            }
            await api.post(APIConstant.path.DeleteCoScholasticTemplate, data).then(async response => {
                let res = response;
                if (res.success) {
                    Loader.hide();
                    Toast.success({ message: 'Co-Scholastic Template deleted successfully' });
                    setDeleteId('');
                    GetCoScholasticTemplateList(securityUserID);
                }
                handleClose();
            }).catch(err => {
                Loader.hide();
                setDeleteId('');
                handleClose();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) { console.log(err);
            catchResponse(err);
         }
    }

    const nameBodyTemplate = (rowData) => {
        const fullName = rowData.CoScholasticNameValue || '';
        const names = fullName.split(',').map(n => n.trim()).filter(Boolean);
        if (names.length <= 3) {
            return <span>{fullName}</span>;
        }
        const displayed = names.slice(0, 3).join(', ');
        const uniqueClass = `name-tooltip-${rowData._id}`;
        return (
            <>
                <span className={uniqueClass} data-pr-tooltip={fullName} style={{ cursor: 'pointer' }}>
                    {displayed}, ...
                </span>
                <Tooltip target={`.${uniqueClass}`} position="top" style={{ maxWidth: '300px' }} />
            </>
        );
    };

    return (
        <div className='wayment-owner-dashboard et-master-page'>
            <div className="heading-area p-d-flex p-ai-center p-jc-between">
                <div className="p-d-flex p-ai-baseline">
                    <i className="pi pi-map"></i>
                    <h2>Co-Scholastic Template</h2>
                </div>
                <div className="p-d-flex p-ai-center p-jc-between">
                    <div className="searchbar-area e-searchbar-area">
                        <i className="pi pi-search" />
                        <InputText
                            value={globalFilterValue}
                            onChange={onGlobalFilterChange}
                            placeholder="Global Search"
                        />
                    </div>
                    <Button icon="pi pi-plus" className="e-h-btn" onClick={() => setVisible(true)} />
                </div>
            </div>
            <DataTable
                value={coScholasticList}
                paginator
                rows={rows}
                first={first}
                filters={filters}
                filterDisplay="menu"
                responsiveLayout="scroll"
                paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink JumpToPageInput"
                rowsPerPageOptions={[5, 10, 20]}
                currentPageReportTemplate="Showing {first}-{last} of {totalRecords} records"
                onPage={onPageChange}
                className='custom-table'
                scrollHeight='calc(100vh - 120px)'
                size='small'
                tableStyle={{ tableLayout: 'fixed' }}
            >
                <Column field="id" body={actionBodyTemplateSrNo} header="Sr No."  style={{ maxWidth: '10%'}} />
                <Column
                    field="TemplateName"
                    header="Title"
                    style={{ maxWidth: '10%'}}
                />
                <Column
                    field="Type"
                    header="Type"
                    style={{ maxWidth: '10%'}}
                />
                <Column
                    field="CoScholasticNameValue"
                    header="Co-Scholastic Name"
                    body={nameBodyTemplate}
                    style={{ width: '50%'}}
                />
                <Column body={actionBodyTemplate} header="Action" headerStyle={{  width: 'auto', textAlign: 'end' }} />
            </DataTable>

            <Dialog
                header={masterData?._id ? 'Edit Co-Scholastic Template' : 'Add Co-Scholastic Template'}
                visible={visible}
                onHide={() => onCancel()}
                draggable={false}
                position="center"
                style={{ maxWidth: '40vw' }}
                contentStyle={{ overflow: 'hidden' }}
            >
                <AddEditCoScholasticTemplateDialog onCancel={onCancel} configId={masterData?._id} masterData={masterData} />

            </Dialog>
            <Dialog
                visible={isDeleteConfirmation}
                onHide={handleClose}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Delete Confirmation</span>
                    </div>
                }
                footer={renderFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <DeleteConfirmation />
            </Dialog>
        </div>
    );
};

export default CoScholasticTemplateConfiguration;
